import {FreeToPlayIconPositionMrGreenBox} from "./free-to-play-icon-position.mrgreen.box";

export const FreeToPlayIconPositionMrGreenCisBox = FreeToPlayIconPositionMrGreenBox;
